// Admin panel JavaScript with Hotwire (Turbo + Stimulus)

import * as Turbo from '@hotwired/turbo'

// Import and start Stimulus controllers
import '../controllers'

// Start Turbo
Turbo.start()

// Disable Turbo prefetch to reduce unnecessary requests in admin panel
Turbo.session.drive = true
Turbo.cache.clear()

// Disable link prefetching globally
document.addEventListener('turbo:before-prefetch', (event) => {
  event.preventDefault()
})

console.log('Admin panel initialized with Turbo + Stimulus')

// Turbo event listeners for debugging (remove in production)
document.addEventListener('turbo:load', () => {
  console.log('Turbo: page loaded')
})

document.addEventListener('turbo:before-fetch-request', (event) => {
  // Add loading state to body
  document.body.classList.add('turbo-loading')
})

document.addEventListener('turbo:before-fetch-response', () => {
  // Remove loading state
  document.body.classList.remove('turbo-loading')
})

// Handle Turbo form submissions
document.addEventListener('turbo:submit-start', (event) => {
  const form = event.target
  const submitButton = form.querySelector('[type="submit"]')

  if (submitButton) {
    submitButton.disabled = true
    submitButton.dataset.originalText = submitButton.textContent
    submitButton.textContent = 'Сохранение...'
  }
})

document.addEventListener('turbo:submit-end', (event) => {
  const form = event.target
  const submitButton = form.querySelector('[type="submit"]')

  if (submitButton) {
    submitButton.disabled = false
    if (submitButton.dataset.originalText) {
      submitButton.textContent = submitButton.dataset.originalText
    }
  }
})
